import { useState } from 'react';
import { encodeWaText, stripAccents } from '../lib/contact';

const TEXTS = {
  'La Clásica':       'Soy una Clásica del Bar Cabrero — aceituna, piparra y anchoa de Santoña. La de toda la vida.',
  'La de Anchoa':     'Soy una de Anchoa del Bar Cabrero — anchoa y aceituna. Mar del norte en dos bocados.',
  'La del Boquerón': 'Soy una del Boquerón del Bar Cabrero — boquerón y aceituna. Fresca y adictiva.',
  'El Matrimonio':    'Soy un Matrimonio del Bar Cabrero — anchoa, boquerón y aceituna. La unión perfecta.',
  'La Ibérica':       'Soy una Ibérica del Bar Cabrero — anchoa, piparra, queso manchego y cecina ibérica.',
  'La de Pulpo':      'Soy una de Pulpo del Bar Cabrero — pulpo, anchoa, piparra y huevo de codorniz.',
  'La de Langostino': 'Soy una de Langostino del Bar Cabrero — langostino, huevo, pimiento y mayonesa.',
  'La de Queso':      'Soy una de Queso del Bar Cabrero — aceituna, piparra, anchoa y queso manchego.',
  'La de Mejillón':   'Soy una de Mejillón del Bar Cabrero — mejillón en escabeche, anchoa y aceituna.',
  'La Verde':         'Soy una Verde del Bar Cabrero — aceituna, piparra, cebollita y tomate seco. La más fresca.',
  'La Ahumada':       'Soy una Ahumada del Bar Cabrero — aceituna, piparra y salmón ahumado. Elegante.',
  'La Picante':       'Soy una Picante del Bar Cabrero — anchoa, piparra, aceituna y alegría. Para los valientes.',
};

export default function ShareGilda({ gilda }) {
  const [copied, setCopied] = useState(false);
  const text = `${TEXTS[gilda] || `Mi gilda es ${gilda}`} ¿Cuál es la tuya? Hazlo en el quiz del Bar Cabrero.`;
  const url = typeof window !== 'undefined' ? `${window.location.origin}/gildas#quiz` : '';
  const full = `${text} ${url}`;

  const onShare = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: `Mi gilda es ${gilda}`, text, url });
        return;
      } catch (err) {
        // User canceled the native share dialog — not an error worth surfacing.
        if (err?.name !== 'AbortError') console.warn('share failed', err);
      }
    }
    try {
      await navigator.clipboard.writeText(full);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (err) {
      // Clipboard blocked (insecure context, permissions). Log for debugging.
      console.warn('clipboard write failed', err);
    }
  };

  return (
    <div className="share-row" data-testid="share-row">
      <span>Comparte</span>
      <button className={`share-btn ${copied ? 'copied' : ''}`} onClick={onShare} data-testid="share-native">
        {copied ? '¡Copiado!' : 'Compartir mi gilda'}
      </button>
      <a
        className="share-btn wa"
        href={`https://wa.me/?text=${encodeWaText(stripAccents(full))}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-whatsapp"
      >
        WhatsApp
      </a>
      <a
        className="share-btn"
        href={`https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="share-twitter"
      >
        X / Twitter
      </a>
    </div>
  );
}
